<template>
  <v-app-bar
    app
    class="app-nav-bar"
    light
    height="48"
  >
    <v-app-bar-nav-icon class="d-flex d-md-none" @click="toggleDrawer"></v-app-bar-nav-icon>
    <v-container class="py-0" fluid>
      <v-row class="align-center breadcrumb-row d-none d-lg-flex">
        <slot name="breadcrumb"></slot>
      </v-row>
      <v-row class="align-center" dense>
        <div class="d-flex align-center logo-container" @click="logoClicked">
          <v-img
            alt="Decidedly Logo"
            class="shrink mr-2"
            contain
            :src="require('../assets/logo-blue.svg')"
            transition="scale-transition"
            width="28"
          />
          Decidedly
        </div>

        <v-spacer class="d-none d-md-flex"></v-spacer>

        <div class="d-none d-md-flex">
          <slot name="menu"></slot>
        </div>

        <v-spacer class="d-flex"></v-spacer>

        <v-menu offset-y :open-on-hover="!$vuetify.breakpoint.mobile" rounded="0">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="top-nav-avatar-button"
              v-bind="attrs"
              v-on="on"
              icon
              dense
            >
              <UserAvatar
                :displayName="currentUser.displayName"
                :email="currentUser.email"
                :photoUrl="currentUser.photoUrl"
                :size="24"
                :marginRight="0"
              />
            </v-btn>
          </template>

          <v-card rounded="0" class="user-menu" dark>
            <v-list>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>{{currentUser.displayName || currentUser.email}}</v-list-item-title>
                  <!-- <v-list-item-subtitle>Member since ...</v-list-item-subtitle> -->
                </v-list-item-content>

              </v-list-item>
            </v-list>

            <v-divider></v-divider>

            <v-list>
              <v-list-item v-if="!$vuetify.breakpoint.mobile">
                <v-list-item-action>
                  <v-switch
                    @click.native.stop
                    v-model="showIntro"
                  ></v-switch>
                </v-list-item-action>
                <v-list-item-title>Show Introduction</v-list-item-title>
              </v-list-item>
              <v-list-item>
                <v-list-item-title>
                  <v-btn class="d-flex" href="#" @click.prevent="logout" text>
                    <span class="mr-2">Logout</span>
                    <v-icon>mdi-logout</v-icon>
                  </v-btn>
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-card>
        </v-menu>

        <!-- <v-btn class="d-none d-md-flex" href="#" @click.prevent="logout" text>
          <span class="mr-2">Logout</span>
          <v-icon>mdi-logout</v-icon>
        </v-btn> -->

      </v-row>
    </v-container>
  </v-app-bar>
</template>

<script>
// This import loads the firebase namespace along with all its type information.
import * as firebase from 'firebase/app'
// Load the auth feature into the firebase namespace.
import 'firebase/auth'

// Mixins
import resetStore from '@/mixins/ResetStore.js'

// Componentns
import UserAvatar from '@/components/UserAvatar.vue'

export default {
  name: 'TopNavBar',
  mixins: [resetStore],
  components: {
    UserAvatar
  },
  data () {
    return {
      currentUser: firebase.auth().currentUser
    }
  },
  computed: {
    showIntro: {
      // getter
      get: function () {
        return !this.$store.state.user.hideIntro
      },
      // setter
      set: function (newValue) {
        // console.log(`Show intro gets new value ${newValue}`)
        this.$store.dispatch('user/updateHideIntro', !newValue)
      }
    }
  },
  // mounted: function () {
  //   console.log(`route path according to top name is ${this.$route.path}`)
  // },
  methods: {
    toggleDrawer: function () {
      this.$emit('onToggleDrawer')
    },
    logoClicked: function () {
      if (this.$route.name !== 'Decisions') {
        this.$router.replace('/decisions')
      }
    },
    logout: function () {
      this.resetAllStoreModules()
      firebase.auth().signOut().then(() => {
        this.$router.replace('/login')
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.user-menu {
  background-color: #0e2887 !important;

  .v-list {
    background: none;
  }
}

.app-nav-bar {
  background-color: #FFF !important;
  color: #222;
  font-family: 'Inter', 'Roboto', sans-serif !important;

  background: /* gradient can be an image */
    linear-gradient(90deg, rgba(127,165,248,1) 0%, rgba(30,64,170,1) 100%)
    left
    bottom
    rgb(127,165,248)
    no-repeat;

  background-size: 100% 2px !important;/* if linear-gradient, we need to resize it */

  .v-btn {
    position: relative;
    height: 48px !important;
    border: solid rgba(127,165,248,0) 1px;
    padding: 0 !important;
    color: #666;
    // text-transform: capitalize;

    .v-btn__content {
      height: 45px !important;
      padding: 0 16px;
      z-index: 4;
      font-size: 11px;
      // font-size: 0.9rem;
      text-transform: capitalize;
      font-weight: 500;
    }

    &:hover {
      color: #222;
    }

    &.active {
      background-color: unset !important;
      color:#3f51b5;

      border-top: solid rgba(255,255,255,1) 1px;
      border-bottom: solid rgba(127,165,248,0.9) 2px;
      border-left: solid rgba(127,165,248,0.4) 1px;
      border-right: solid rgba(127,165,248,0.3) 1px;

      .v-btn__content {
        background: #FFF !important;
      }

      &::after {
        content: "";
        position: absolute;
        bottom: 3;
        width: 15%;
        height: 2px;
        box-shadow: 0px 10px 28px 13px rgba(127,165,248,1);
        z-index: 1;
      }
    }
  }

  .logo-container {
    color: #1e40aa;
    text-transform: uppercase;
    cursor: pointer;
    margin-bottom: 2px;
  }

  .breadcrumb-row {
    position: absolute;
    top: 12px;
    margin-left: 9px;
  }

  .top-nav-avatar-button {
    // margin-right: -10px;
  }

}

</style>
